const CONFIG = {
    QUANTITY_STEP: 10,
    BUNDLE_PRESETS: {
      60: [20, 20, 20, 0],
      120: [40, 40, 40, 0],
      250: [90, 80, 80, 0],
      500: [180, 160, 160, 0],
    },
  };
  
  console.log = function () {};
  
  const createDelegate = (element) => {
    const on = (event, selector, handler) => {
      element.addEventListener(event, (e) => {
        if (e.target.closest(selector)) {
          handler(e);
        }
      });
    };
  
    return { on };
  };
  
  const setTextContent = (element, selector, text) => {
    const targetElement = element.querySelector(selector);
    if (targetElement) {
      targetElement.textContent = text;
    }
  };
  
  const rtxnBundleProducts = (() => {
    const rtxnScript = document.querySelector("[data-rtxn-bundle-products]");
    if (!rtxnScript) return null;
    const bundleProductsString = JSON.parse(rtxnScript.innerHTML);
    if (!bundleProductsString) return null;
    return bundleProductsString.split("|").filter((id) => id.trim() !== "");
  })();
  
  const getProductData = () => {
    const productScript = document.querySelector("[data-product-json]");
    if (!productScript) {
      console.warn("Product JSON script not found");
      return null;
    }
  
    try {
      const productData = JSON.parse(productScript.innerHTML);
      console.log("Product data loaded:", productData);
      return productData;
    } catch (error) {
      console.error("Error parsing product JSON:", error);
      return null;
    }
  };
  
  // Function to get all coffy quantity selector products
  const getCoffyQuantityProducts = () => {
    try {
      const quantityBlocks = document.querySelectorAll(".smarch-quantity__block");
      const products = [];
  
      quantityBlocks.forEach((block, index) => {
        const variantsScript = block.querySelector("script[data-variants-json]");
        let variants = [];
  
        if (variantsScript) {
          try {
            variants = JSON.parse(variantsScript.textContent);
          } catch (e) {
            console.warn(
              "Failed to parse variants JSON for quantity block",
              index,
              e
            );
          }
        }
  
        const productData = {
          index: index,
          quantity: block.dataset.quantity,
          baseProductId: block.dataset.base,
          baseVariantId: block.dataset.baseVariant,
          price: block.dataset.price,
          variants: variants,
          isActive: block.classList.contains("is-active"),
          element: block,
        };
  
        products.push(productData);
      });
  
      return products;
    } catch (error) {
      console.error("Error getting coffy quantity products:", error);
      return [];
    }
  };
  
  // Function to get the currently active coffy quantity product
  const getActiveCoffyQuantityProduct = () => {
    try {
      const activeBlock = document.querySelector(
        ".smarch-quantity__block.is-active"
      );
      if (!activeBlock) {
        return null;
      }
  
      const variantsScript = activeBlock.querySelector(
        "script[data-variants-json]"
      );
      let variants = [];
  
      if (variantsScript) {
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
          console.warn(
            "Failed to parse variants JSON for active quantity block",
            e
          );
        }
      }
  
      return {
        quantity: activeBlock.dataset.quantity,
        baseProductId: activeBlock.dataset.base,
        baseVariantId: activeBlock.dataset.baseVariant,
        price: activeBlock.dataset.price,
        variants: variants,
        element: activeBlock,
      };
    } catch (error) {
      console.error("Error getting active coffy quantity product:", error);
      return null;
    }
  };
  
  const setBundlePrice = (fullPrice, discountedPrice) => {
    // Only render fullPrice if the two prices differ
    if (fullPrice !== discountedPrice) {
      setTextContent(
        document,
        ".subscriptions__header-price--before",
        formatPriceShopify(fullPrice / 100)
      );
    }
  
    if (fullPrice !== discountedPrice && discountedPrice < fullPrice) {
      const savings = fullPrice - discountedPrice;
      const percentageOff = Math.round((savings / fullPrice) * 100);
  
      setTextContent(
        document,
        ".subscriptions__header-price--percentage",
        "save " + percentageOff + "%"
      );
    }
  
    setTextContent(
      document,
      ".subscriptions__header-price--after",
      formatPriceShopify(discountedPrice / 100)
    );
  };
  
  /**
   * Formats a price for Shopify
   *
   * @param {number|string} priceInput
   *
   * @return {string}
   */
  function formatPriceShopify(priceInput) {
    const price =
      typeof priceInput === "number" ? priceInput : Number(priceInput);
  
    const currency = window.Shopify.currency.active || "EUR";
    const language = (window.Shopify.locale || "en").split("-")[0];
    const country = window.Shopify.country || "DE";
  
    // Round to whole numbers for non-EUR currencies
    const fractionDigits = currency === "EUR" || currency === "GBP" ? 2 : 0;
  
    // Format the price using Intl.NumberFormat
    const formatted = new Intl.NumberFormat(`${language}-${country}`, {
      style: "decimal",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price);
  
    // For NOK currency, return in format "XX kr"
    if (currency === "NOK") {
      return `${formatted} kr.`;
    }
  
    // For other currencies, use standard currency formatting
    return new Intl.NumberFormat(`${language}-${country}`, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price);
  }
  
  // Update subscription pricing displays based on quantity and total price
  const setPerUnitPrices = (quantity) => {
    const bundleFormElement = document.querySelector("bundle-form");
    if (!bundleFormElement) return;
    const coffyQuantityProducts = getCoffyQuantityProducts();
  
    if (coffyQuantityProducts && coffyQuantityProducts.length > 1) {
      const currentActiveQuantity = getActiveCoffyQuantityProduct();
      console.log("currentActiveQuantity :", currentActiveQuantity);
      const subPrice = currentActiveQuantity.price;
      const parsedDiscountedPrice =
        typeof subPrice === "string"
          ? Math.round(
              parseFloat(subPrice.replace(/[^\d.,]/g, "").replace(",", "."))
            )
          : subPrice;
      console.log("parsedDiscountedPrice type:", typeof parsedDiscountedPrice);
      console.log("parsedDiscountedPrice 123: ", parsedDiscountedPrice);
      const onetimePrice = parseFloat(
        bundleFormElement.dataset.otpPrice / 100 || 0
      ).toFixed(2);
  
      // Create currency formatter for better precision
      const currencyFormatter = new Intl.NumberFormat("en-EU", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
      const subscriptionPricePerUnit = currencyFormatter.format(
        parsedDiscountedPrice / quantity
      );
      const onetimePricePerUnit = currencyFormatter.format(
        onetimePrice / quantity
      );
  
      // Update subscription option pricing
      setTextContent(
        document,
        ".subscriptions__option--recurring .subscriptions__amount--number",
        quantity + " capsules"
      );
      setTextContent(
        document,
        ".subscriptions__option--recurring .subscriptions__amount--per",
        "(" + formatPriceShopify(subscriptionPricePerUnit) + " per capsule)"
      );
  
      // Update one-time option pricing
      setTextContent(
        document,
        ".subscriptions__option--onetime .subscriptions__amount--number",
        quantity + " capsules"
      );
      setTextContent(
        document,
        ".subscriptions__option--onetime .subscriptions__amount--per",
        "(" + formatPriceShopify(onetimePricePerUnit) + " per capsule)"
      );
  
      setTextContent(
        document,
        ".subscriptions__header-price--onetime",
        formatPriceShopify(onetimePrice)
      );
    } else {
      // Get pricing data from bundle form element
      const subscriptionPrice = parseFloat(
        bundleFormElement.dataset.subPrice / 100 || 0
      ).toFixed(2);
      const onetimePrice = parseFloat(
        bundleFormElement.dataset.otpPrice / 100 || 0
      ).toFixed(2);
  
      const subscriptionPricePerUnit = (subscriptionPrice / quantity).toFixed(2);
      const onetimePricePerUnit = (onetimePrice / quantity).toFixed(2);
  
      // Update subscription option pricing
      setTextContent(
        document,
        ".subscriptions__option--recurring .subscriptions__amount--number",
        quantity + " capsules"
      );
      setTextContent(
        document,
        ".subscriptions__option--recurring .subscriptions__amount--per",
        "(" + formatPriceShopify(subscriptionPricePerUnit) + " per capsule)"
      );
  
      // Update one-time option pricing
      setTextContent(
        document,
        ".subscriptions__option--onetime .subscriptions__amount--number",
        quantity + " capsules"
      );
      setTextContent(
        document,
        ".subscriptions__option--onetime .subscriptions__amount--per",
        "(" + formatPriceShopify(onetimePricePerUnit) + " per capsule)"
      );
  
      setTextContent(
        document,
        ".subscriptions__header-price--onetime",
        formatPriceShopify(onetimePrice)
      );
    }
  };
  
  // Quantity Control Component
  const createQuantityControl = (element) => {
    let buyButton = null;
  
    const delegate = createDelegate(element);
  
    const initialize = () => {
      const quantityBlock = element.querySelector(".smarch-quantity__block");
      if (quantityBlock) {
        buyButton = element.querySelector(".product__submit__bundle");
  
        changeQuantity();
        prefillBundleQuantities();
      }
    };
  
    const setupEventListeners = () => {
      delegate.on("click", '[data-action="update-quantity"]', onUpdateQuantity);
      delegate.on("click", '[data-action="toggle-quantity"]', changeQuantity);
    };
  
    const changeQuantity = (event) => {
      const totalElement = element.querySelector(".smarch-flavor__amount");
      const currentActive = element.querySelector(
        ".smarch-quantity__block.is-active"
      );
  
      const coffyQuantityProducts = getCoffyQuantityProducts();
      console.log("coffyQuantityProducts: ", coffyQuantityProducts);
  
      const activeCoffyQuantityProduct = getActiveCoffyQuantityProduct();
      console.log("activeCoffyQuantityProduct: ", activeCoffyQuantityProduct);
  
      console.log("active", currentActive);
      const quantity = parseInt(currentActive.dataset.quantity);
  
      totalElement.dataset.current = 0;
      totalElement.textContent = `0 / ${quantity}`;
  
      if (currentActive && event) {
        currentActive.classList.remove("is-active");
      }
  
      if (event) {
        event.target.classList.add("is-active");
  
        const quantity = parseInt(event.target.dataset.quantity);
        totalElement.dataset.max = quantity;
  
        totalElement.dataset.current = 0;
        totalElement.textContent = `0 / ${quantity}`;
  
        // Update bundle form data attributes
        const currentActiveQuantity = getActiveCoffyQuantityProduct();
        console.log("currentActiveQuantity :", currentActiveQuantity);
  
        const firstVariant = currentActiveQuantity.variants[0];
        console.log("firstVariant :", firstVariant);
        const otpPrice = firstVariant.price;
        const subPrice =
          firstVariant.selling_plan_allocations[0].price_adjustments[0].price;
        console.log("subPrice: ", subPrice);
  
        const bundleForm = document.querySelector("bundle-form");
        if (bundleForm) {
          bundleForm.setAttribute("data-otp-bundle-max", quantity);
          bundleForm.setAttribute("data-sub-bundle-max", quantity);
          bundleForm.dataset.otpPrice = otpPrice;
          bundleForm.dataset.subPrice = subPrice;
        }
  
        const bundleBlock =
          event.target.closest(".product__block") ||
          event.target.closest("bundle-form") ||
          event.target.closest(".smarch-bundle-product-set-list");
        console.log("bundleBlock: ", bundleBlock);
        if (bundleBlock) {
          bundleBlock.dataset.otpPrice = otpPrice;
          bundleBlock.dataset.subPrice = subPrice;
  
          setBundlePrice(otpPrice, subPrice);
        }
      }
  
      resetTotals();
      prefillBundleQuantities();
  
      // Regenerate frequency selector when quantity changes
      const subscriptionControl = document.querySelector(".subscriptions");
      if (subscriptionControl && subscriptionControl._subscriptionControl) {
        subscriptionControl._subscriptionControl.generateFrequencySelector();
      }
    };
  
    const resetTotals = () => {
      element
        .querySelectorAll(".smarch-flavor__item-quantity input")
        .forEach((input) => {
          input.value = 0;
        });
      updateButtonStates();
    };
  
    const updateButtonStates = () => {
      const allInputs = element.querySelectorAll(
        ".smarch-flavor__item-quantity input"
      );
      const totalElement = element.querySelector(".smarch-flavor__amount");
      const currentQuantity = parseInt(totalElement.dataset.current);
      const maxQuantity = parseInt(totalElement.dataset.max);
  
      // Check if subscription control exists on the page
      // const subscriptionControl = document.querySelector(".subscriptions");
      // const hasSubscriptionControl = subscriptionControl !== null;
  
      const quantityTitle = document.querySelector(".smarch-quantity__title")    
      const flavorTitle = document.querySelector(".smarch-flavor__title")
      const flavorAmount = document.querySelector(".smarch-flavor__amount")
      const flavorHeader = document.querySelector(".smarch-flavor__header")
  
      allInputs.forEach((input) => {
        const value = parseInt(input.value);
        const quantityContainer = input.closest(".smarch-flavor__item-quantity");
        const minusButton = quantityContainer.querySelector(
          '[data-direction="minus"]'
        );
        const plusButton = quantityContainer.querySelector(
          '[data-direction="plus"]'
        );
  
        // For products without subscription control, disable both buttons
        if (false) {
          minusButton.style.display = "none";
          plusButton.style.display = "none";
          flavorTitle.style.display = "none";
          flavorAmount.style.display = "none";
          // change text to "Flavors"
          quantityTitle.textContent = "Flavors";
          // Remove the flavor header element from the DOM entirely
          if (flavorHeader && flavorHeader.parentNode) {
            flavorHeader.parentNode.removeChild(flavorHeader);
          }
        } else {
          // Original logic for products with subscription control
          minusButton.disabled = value <= 0;
          plusButton.disabled = currentQuantity >= maxQuantity;
          if (buyButton) {
            buyButton.disabled = currentQuantity < maxQuantity;
          }
        }
        
        
      });
    };
  
    const onUpdateQuantity = (event) => {
      // Check if subscription control exists on the page
      const subscriptionControl = document.querySelector(".subscriptions");
      // const hasSubscriptionControl = subscriptionControl !== null;
  
      // For products without subscription control, prevent quantity changes
      // if (!hasSubscriptionControl) {
      //   return;
      // }
  
      const quantityContainer = event.target.closest(
        ".smarch-flavor__item-quantity"
      );
      const inputElement = quantityContainer.querySelector("input");
      const inputValue = parseInt(inputElement.value);
      const direction = event.target.dataset.direction;
      const totalElement = element.querySelector(".smarch-flavor__amount");
      const maxQuantity = parseInt(totalElement.dataset.max);
  
      let currentQuantity = parseInt(totalElement.dataset.current);
      let newValue = inputValue;
  
      if (
        direction === "plus" &&
        currentQuantity + CONFIG.QUANTITY_STEP <= maxQuantity
      ) {
        newValue += CONFIG.QUANTITY_STEP;
        currentQuantity += CONFIG.QUANTITY_STEP;
      } else if (
        direction === "minus" &&
        inputValue - CONFIG.QUANTITY_STEP >= 0
      ) {
        newValue -= CONFIG.QUANTITY_STEP;
        currentQuantity -= CONFIG.QUANTITY_STEP;
      }
  
      inputElement.value = newValue;
      totalElement.dataset.current = currentQuantity;
      totalElement.textContent = `${currentQuantity} / ${maxQuantity}`;
      updateButtonStates();
    };
  
    // Listen for custom events
    element.addEventListener("updateButtonStates", () => {
      updateButtonStates();
    });
  
    // Initialize component
    initialize();
    setupEventListeners();
  
    // Store component methods on the element for external access
    element._quantityControl = {
      changeQuantity,
      onUpdateQuantity,
      updateButtonStates,
      resetTotals,
    };
  
    return {
      changeQuantity,
      onUpdateQuantity,
      updateButtonStates,
      resetTotals,
    };
  };
  
  function getGuid() {
    let d = new Date().getTime();
    let d2 = (performance && performance.now && performance.now() * 1000) || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      let r = Math.random() * 16;
      if (d > 0) {
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
    });
  }
  
  function getBundleBlock(trigger) {
    // First try to find the bundle-form element
    const bundleForm = trigger.closest("bundle-form");
    if (bundleForm) {
      return bundleForm;
    }
  
    // Fallback to looking for the product block container
    return (
      trigger.closest(".product__block") ||
      trigger.closest(".smarch-bundle-product-set-list")
    );
  }
  
  // Get the currently selected color for bonus items
  function getSelectedColor() {
    const activeColorElement = document.querySelector(
      ".smarch-color__block.is-active"
    );
    if (activeColorElement) {
      const colorName = activeColorElement.dataset.color;
      // Convert color name to lowercase to match bonus item variants
      return colorName ? colorName.toLowerCase() : "default";
    }
    return "default";
  }
  
  function addToCart(trigger) {
    console.log("🛒 === ADD TO CART FUNCTION STARTED ===");
    console.log("📍 Trigger element:", trigger);
  
    const bundleID = getGuid();
    console.log("🆔 Generated Bundle ID:", bundleID);
  
    const bundleBlock = getBundleBlock(trigger);
    console.log("📦 Bundle Block found:", bundleBlock);
    console.log("📦 Bundle Block tag name:", bundleBlock?.tagName);
  
    // Handle different bundle block types
    let bundleForm, bundleFormElement;
    if (bundleBlock.tagName === "BUNDLE-FORM") {
      console.log("✅ Bundle block is BUNDLE-FORM type");
      bundleFormElement = bundleBlock;
      bundleForm = bundleBlock.querySelector(".smarch-bundle-form");
    } else {
      console.log("✅ Bundle block is standard type, searching for elements");
      bundleForm = bundleBlock.querySelector(".smarch-bundle-form");
      bundleFormElement = bundleBlock.querySelector("bundle-form");
    }
  
    console.log("📋 Bundle Form:", bundleForm);
    console.log("📋 Bundle Form Element:", bundleFormElement);
  
    if (!bundleForm || !bundleFormElement) {
      console.error("❌ Bundle form or bundle form element not found");
      console.error("❌ bundleForm:", bundleForm);
      console.error("❌ bundleFormElement:", bundleFormElement);
      return false;
    }
  
    const bundleProductID = bundleForm.querySelector('input[name="id"]').value;
    console.log("🏷️ Bundle Product ID:", bundleProductID);
  
    const realProductID = bundleForm.querySelector(
      'input[name="product_id"]'
    ).value;
    console.log("🏷️ Real Product ID:", realProductID);
  
    // Handle cases where subscription form doesn't exist - assume OTP
    const bundleSellingPlanElement = document.querySelector(
      'input[name="properties[_interval]"]'
    );
    const bundleSubscriptionElement = document.querySelector(
      'input[name="properties[_subscription]"]'
    );
  
    console.log("🔄 Selling Plan Element:", bundleSellingPlanElement);
    console.log("🔄 Subscription Element:", bundleSubscriptionElement);
  
    const subscriptionControl = document.querySelector(".subscriptions");
  
    const bundleSellingPlan = bundleSellingPlanElement
      ? bundleSellingPlanElement.value
      : "";
    const bundleSubscription = bundleSubscriptionElement
      ? bundleSubscriptionElement.disabled
      : "";
    const interval = !subscriptionControl ? "otp" : bundleSubscription == "" ? "otp" : "sub";
  
    console.log("🔄 Bundle Selling Plan:", bundleSellingPlan);
    console.log("🔄 Bundle Subscription Disabled:", bundleSubscription);
    console.log("🔄 Purchase Interval Type:", interval);
  
    // Get bundle limits from the bundle-form element
    const bundleMin =
      interval == "otp"
        ? bundleFormElement.dataset.otpBundleMin
        : bundleFormElement.dataset.subBundleMin ||
          bundleFormElement.dataset.otpBundleMin;
    const bundleMax =
      interval == "otp"
        ? bundleFormElement.dataset.otpBundleMax
        : bundleFormElement.dataset.subBundleMax ||
          bundleFormElement.dataset.otpBundleMax;
  
    console.log("📊 === BUNDLE LIMITS & QUANTITY INFO ===");
    console.log("📊 Purchase Interval:", interval);
    console.log("📊 Bundle Min Quantity:", bundleMin);
    console.log("📊 Bundle Max Quantity:", bundleMax);
    console.log("📊 Bundle Form Element Dataset:", bundleFormElement.dataset);
  
    // Find the bundle product list - it might be in a different location
    console.log("🔍 === SEARCHING FOR BUNDLE PRODUCT LIST ===");
    let bundleProductList = bundleBlock.querySelector(
      ".smarch-bundle-product-set-list"
    );
    console.log("🔍 Bundle product list in bundleBlock:", bundleProductList);
  
    if (!bundleProductList) {
      console.log("🔍 Not found in bundleBlock, searching in document...");
      // Look for it in the document if not found in bundleBlock
      bundleProductList = document.querySelector(
        ".smarch-bundle-product-set-list"
      );
      console.log("🔍 Bundle product list in document:", bundleProductList);
    }
  
    if (!bundleProductList) {
      console.error("❌ Bundle product list not found anywhere");
      return false;
    }
  
    const bundleProductListInputs = bundleProductList.querySelectorAll(
      ".smarch-bundle-product-select-quantity-input"
    );
    console.log(
      "🔢 Bundle product quantity inputs found:",
      bundleProductListInputs.length
    );
    console.log("🔢 Bundle product quantity inputs:", bundleProductListInputs);
  
    let bundleCart = {
      items: [],
    };
    let bundleProductQuantity = 0;
    console.log("🛒 Initialized empty bundle cart:", bundleCart);
  
    // Get current active element and set price to bundleBlock
    console.log("💰 === PRICE CALCULATION ===");
    const currentActive = document.querySelector(
      ".smarch-quantity__block.is-active"
    );
    console.log("💰 Current active quantity block:", currentActive);
    console.log("💰 Current active price data:", currentActive?.dataset?.price);
  
    if (currentActive && currentActive.dataset.price) {
      // Set the price to bundleBlock dataset
      console.log("💰 Setting bundleBlock price from active element");
      bundleBlock.dataset.price = currentActive.dataset.price;
      console.log("💰 Set bundleBlock price to:", currentActive.dataset.price);
    }
  
    // Create bundle parent item
    console.log("👑 === CREATING BUNDLE PARENT ITEM ===");
    {
      // Always use variant IDs for cart items - Shopify cart API requires variant IDs, never product IDs
      let cartItemId;
      if (currentActive && currentActive.dataset.baseVariant) {
        // Use the base variant from the active quantity selection
        cartItemId = currentActive.dataset.baseVariant;
        console.log("👑 Using base variant from active element:", cartItemId);
      } else {
        // Fallback to bundleProductID (should be a variant ID)
        cartItemId = bundleProductID;
        console.log("👑 Using bundleProductID as fallback:", cartItemId);
      }
  
      console.log("👑 Final cart item ID (must be variant ID):", cartItemId);
      console.log(
        "👑 Current active element data-base-variant:",
        currentActive?.dataset?.baseVariant
      );
      console.log("👑 Bundle Product ID (should be variant):", bundleProductID);
      console.log("👑 Real Product ID (main product):", realProductID);
      console.log("👑 Purchase type:", interval);
  
      let cartItem = {
        id: cartItemId,
        quantity: 1,
        properties: {
          _bundle_id: bundleID,
          _bundle_parent: true,
        },
      };
      console.log("👑 Initial cart item structure:", cartItem);
  
      const otpPrice = bundleBlock.dataset.otpPrice;
      const subPrice = bundleBlock.dataset.subPrice;
      // Add price based on subscription status
      console.log("💰 === PRICE ASSIGNMENT LOGIC ===");
      console.log("💰 Interval type:", interval);
      console.log("💰 Bundle block sub price:", bundleBlock.dataset.subPrice);
      console.log("💰 Bundle block otp price:", bundleBlock.dataset.otpPrice);
  
      if (interval == "sub" && subPrice) {
        // Use subscription price (already in cents)
        cartItem.price = parseInt(subPrice);
        console.log("💰 ✅ Using subscription price:", cartItem.price, "cents");
      } else if (interval == "otp" && otpPrice) {
        // Use one-time price (already in cents)
        cartItem.price = parseInt(otpPrice);
        console.log("💰 ✅ Using one-time price:", cartItem.price, "cents");
      } else if (currentActive && currentActive.dataset.price) {
        // Fallback to currentActive price
        const priceStr = currentActive.dataset.price
          .replace(/[^\d.,]/g, "")
          .replace(",", ".");
        cartItem.price = Math.round(parseFloat(priceStr) * 100);
        console.log("💰 ✅ Using fallback price from active element:");
        console.log("💰   - Original price string:", currentActive.dataset.price);
        console.log("💰   - Cleaned price string:", priceStr);
        console.log("💰   - Final price in cents:", cartItem.price);
      } else {
        console.log(
          "💰 ⚠️ No price found - cart item will have no price property"
        );
      }
  
      // Add subscription properties if subscription is enabled
      if (interval == "sub") {
        if (bundleSellingPlan && bundleSellingPlan !== "") {
          cartItem["selling_plan"] = bundleSellingPlan;
          console.log(
            "🔄 ✅ Added selling plan to cart item:",
            bundleSellingPlan
          );
          console.log("🔄 ✅ Variant ID for selling plan:", cartItemId);
        } else {
          console.error("❌ Subscription selected but no selling plan found!");
          console.error("❌ bundleSellingPlan:", bundleSellingPlan);
          return false;
        }
      } else {
        console.log("🔄 ℹ️ No selling plan needed for one-time purchase");
        // For one-time purchases, add subscription price as compare_at_price for discount calculation
        if (subPrice) {
          cartItem.properties._subscription_price = subPrice;
          console.log(
            "💰 ✅ Added subscription price as compare_at_price for OTP:",
            subPrice,
            "cents"
          );
        }
      }
  
      bundleCart.items.push(cartItem);
      console.log(
        "👑 ✅ Bundle parent item created and added to cart:",
        cartItem
      );
      console.log("🛒 Current cart state:", bundleCart);
    }
  
    // Add bundle product items
    console.log("🛍️ === PROCESSING BUNDLE PRODUCT ITEMS ===");
    console.log(
      "🛍️ Number of product inputs to process:",
      bundleProductListInputs.length
    );
  
    bundleProductListInputs.forEach(function (bundleProductInput, index) {
      const inputValue = parseInt(bundleProductInput.value);
      const productId = bundleProductInput.dataset.product;
      const quantityToAdd = inputValue / 10;
  
      console.log(`🛍️ Processing product ${index + 1}:`);
      console.log(`🛍️   - Product ID: ${productId}`);
      console.log(`🛍️   - Input value: ${inputValue}`);
      console.log(`🛍️   - Quantity to add: ${quantityToAdd}`);
  
      bundleProductQuantity = bundleProductQuantity + quantityToAdd;
      console.log(`🛍️   - Running total quantity: ${bundleProductQuantity}`);
  
      if (inputValue > 0) {
        console.log(`🛍️   - ✅ Adding product to cart (quantity > 0)`);
        let cartItem = {
          id: productId,
          quantity: quantityToAdd,
          properties: {
            _bundle_id: bundleID,
          },
        };
  
        // Add subscription properties if subscription is enabled
        if (interval == "sub") {
          if (bundleSellingPlan && bundleSellingPlan !== "") {
            cartItem["selling_plan"] = bundleSellingPlan;
            console.log(`🛍️   - ✅ Added selling plan: ${bundleSellingPlan}`);
            console.log(`🛍️   - ✅ Variant ID: ${productId}`);
          } else {
            console.error(
              `❌ Subscription selected but no selling plan for product ${productId}!`
            );
            return false;
          }
        }
  
        bundleCart.items.push(cartItem);
        console.log(`🛍️   - ✅ Cart item created:`, cartItem);
      } else {
        console.log(`🛍️   - ⏭️ Skipping product (quantity = 0)`);
      }
    });
  
    console.log("🛍️ ✅ Finished processing all products");
    console.log("🛍️ Final bundle product quantity:", bundleProductQuantity);
    console.log("🛒 Current cart with all items:", bundleCart);
  
    // Validate bundle quantity
    console.log("✅ === BUNDLE QUANTITY VALIDATION ===");
    const minAllowed = bundleMin / 10;
    const maxAllowed = bundleMax / 10;
    console.log("✅ Bundle quantity limits:");
    console.log(`✅   - Min allowed: ${minAllowed} (from ${bundleMin})`);
    console.log(`✅   - Max allowed: ${maxAllowed} (from ${bundleMax})`);
    console.log(`✅   - Current quantity: ${bundleProductQuantity}`);
  
    if (
      // bundleProductQuantity > maxAllowed ||
      // bundleProductQuantity < minAllowed
      bundleProductQuantity !== maxAllowed
    ) {
      console.error(
        "❌ VALIDATION FAILED: Quantity is not within bundle size limits"
      );
      console.error(
        `❌ Current: ${bundleProductQuantity}, Min: ${minAllowed}, Max: ${maxAllowed}`
      );
      return false;
    }
  
    console.log("✅ ✅ Bundle quantity validation passed");
  
    // Add bonus items if this bundle has them
    console.log("🎁 === BONUS ITEMS PROCESSING ===");
    const selectedColor = getSelectedColor();
    console.log("🎁 Selected color for bonus items:", selectedColor);
  
    // Check if rtxnBundleProducts exists before processing bonus items
    if (!rtxnBundleProducts) {
      console.log(
        "🎁 ⚠️ No bundle products data found (rtxnBundleProducts is null)"
      );
      console.log("🎁 ⚠️ Skipping bonus items processing");
    }
  
    const bonusItems = rtxnBundleProducts
      ? getBonusItemsForBundle(rtxnBundleProducts, selectedColor)
      : [];
    console.log("🎁 Bonus items found:", bonusItems);
    console.log("🎁 Number of bonus items:", bonusItems.length);
  
    if (bonusItems.length > 0) {
      console.log("🎁 ✅ Processing bonus items for bundle:");
      console.log(`🎁   - Real Product ID: ${realProductID}`);
      console.log(`🎁   - Selected Color: ${selectedColor}`);
      console.log(`🎁   - Bonus Items: ${bonusItems}`);
  
      bonusItems.forEach(function (bonusItemId, index) {
        console.log(`🎁 Creating bonus item ${index + 1}:`);
        console.log(`🎁   - Bonus Item ID: ${bonusItemId}`);
  
        let bonusCartItem = {
          id: bonusItemId,
          quantity: 1,
          properties: {
            _bundle_id: bundleID,
            _bundle_bonus_id: bundleID,
          },
        };
        // if (interval == "sub") {
        //   bonusCartItem["selling_plan"] = bundleSellingPlan;
        // }
  
        console.log(`🎁   - ✅ Bonus cart item created:`, bonusCartItem);
  
        bundleCart.items.push(bonusCartItem);
        console.log(`🎁   - ✅ Added to cart`);
      });
    } else {
      console.log("🎁 ℹ️ No bonus items to add");
    }
  
    console.log("🛒 === FINAL CART SUBMISSION ===");
    console.log("🛒 Final bundle cart to submit:", bundleCart);
    console.log("🛒 Total items in cart:", bundleCart.items.length);
    console.log("🛒 Cart JSON payload:", JSON.stringify(bundleCart, null, 2));
  
    // Verify all IDs are variant IDs before submission
    console.log("🔍 === ID VERIFICATION ===");
    bundleCart.items.forEach((item, index) => {
      console.log(
        `🔍 Item ${index + 1}: ID = ${item.id}, Type = ${typeof item.id}`
      );
      console.log(`🔍   - Quantity: ${item.quantity}`);
      console.log(`🔍   - Is BONUS ITEM: ${!!item._bundle_bonus_id}`);
      console.log(`🔍   - Has selling_plan: ${!!item.selling_plan}`);
      console.log(`🔍   - Properties:`, item.properties);
      // Verify these are all variant IDs (should be numeric strings)
      if (!item.id || isNaN(item.id)) {
        console.error(`❌ Invalid variant ID detected: ${item.id}`);
      }
    });
  
    console.log("🌐 === SUBMITTING TO SHOPIFY CART API ===");
    console.log("🌐 Making POST request to /cart/add.js");
  
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(bundleCart),
      credentials: "same-origin",
    })
      .then((response) => {
        console.log("🌐 === CART API RESPONSE ===");
        console.log("🌐 Response status:", response.status);
        console.log("🌐 Response headers:", response.headers);
        console.log("🌐 Full response object:", response);
  
        if (response.status == 200) {
          console.log("🌐 ✅ Cart API request successful!");
          console.log("🌐 Opening slide cart...");
          // window.location.href = "/cart";
          lsgSlideCartOpen();
          console.log("🛒 === ADD TO CART FUNCTION COMPLETED SUCCESSFULLY ===");
        } else {
          console.error(
            "🌐 ❌ Cart API request failed with status:",
            response.status
          );
        }
      })
      .catch((error) => {
        console.error("🌐 ❌ === CART API ERROR ===");
        console.error("🌐 ❌ Error details:", error);
        console.error("🌐 ❌ Error message:", error.message);
        console.error("🌐 ❌ Error stack:", error.stack);
      });
  
    console.log("🛒 === ADD TO CART FUNCTION EXECUTION COMPLETED ===");
  }
  
  // Subscription Control Component
  const createSubscriptionControl = (element) => {
    const delegate = createDelegate(element);
  
    const initialize = () => {
      // Set initial state - subscription option active by default
      const subscriptionOption = element.querySelector(
        ".subscriptions__option--recurring"
      );
      const onetimeOption = element.querySelector(
        ".subscriptions__option--onetime"
      );
  
      if (subscriptionOption && onetimeOption) {
        setActiveSubscription("recurring");
      }
  
      // Generate frequency selector from selling plan allocations
      generateFrequencySelector();
    };
  
    const generateFrequencySelector = () => {
      const frequencySelector = element.querySelector(
        "#subscriptions__frequence-selector"
      );
      if (!frequencySelector) return;
  
      // Get active quantity product to access selling plan allocations
      const activeCoffyProduct = getActiveCoffyQuantityProduct();
      if (
        !activeCoffyProduct ||
        !activeCoffyProduct.variants ||
        activeCoffyProduct.variants.length === 0
      ) {
        console.warn(
          "No active coffy product or variants found for frequency selector"
        );
        return;
      }
  
      // Get the first variant's selling plan allocations
      const firstVariant = activeCoffyProduct.variants[0];
      if (
        !firstVariant.selling_plan_allocations ||
        firstVariant.selling_plan_allocations.length === 0
      ) {
        console.warn("No selling plan allocations found for frequency selector");
        return;
      }
  
      // Extract unique selling plans
      const sellingPlans = firstVariant.selling_plan_allocations.map(
        (allocation) => allocation.selling_plan
      );
  
      // Generate frequency options HTML
      const frequencyOptionsHTML = sellingPlans
        .map((plan, index) => {
          const optionName = plan.name;
          const isSelected = index === 0; // Default to first option
  
          return `
          <li class="select-popout__item ${
            isSelected ? "select-popout__item--current" : ""
          }">
            <a class="select-popout__option" href="#" ${
              isSelected ? 'aria-current="true"' : ""
            } 
               data-value="${optionName}" 
               data-selling-plan-id="${plan.id}" 
               data-popout-option>
              ${optionName}
            </a>
          </li>
        `;
        })
        .join("");
  
      // Update the frequency selector HTML
      const popoutList = frequencySelector.querySelector(
        ".select-popout__list__scroll"
      );
      const popoutText = frequencySelector.querySelector("[data-popout-text]");
      const popoutInput = frequencySelector.querySelector("[data-popout-input]");
  
      if (popoutList) {
        popoutList.innerHTML = frequencyOptionsHTML;
      }
  
      if (popoutText && sellingPlans.length > 0) {
        popoutText.textContent = sellingPlans[0].name.replace(
          "Delivered every ",
          ""
        );
      }
  
      if (popoutInput && sellingPlans.length > 0) {
        popoutInput.value = sellingPlans[0].id;
      }
  
      // Setup event listeners for the new options
      setupFrequencyEventListeners();
    };
  
    const setupFrequencyEventListeners = () => {
      const frequencySelector = element.querySelector(
        "#subscriptions__frequence-selector"
      );
      if (!frequencySelector) return;
  
      // Remove existing listeners
      const existingOptions = frequencySelector.querySelectorAll(
        "[data-popout-option]"
      );
      existingOptions.forEach((option) => {
        option.removeEventListener("click", handleFrequencySelection);
      });
  
      // Add new listeners
      existingOptions.forEach((option) => {
        option.addEventListener("click", handleFrequencySelection);
      });
    };
  
    const handleFrequencySelection = (event) => {
      event.preventDefault();
      const option = event.target.closest("[data-popout-option]");
      if (!option) return;
  
      const sellingPlanId = option.getAttribute("data-selling-plan-id");
      const optionValue = option.getAttribute("data-value");
  
      // Update hidden input
      const popoutInput = element.querySelector(
        "#subscriptions__frequence-selector [data-popout-input]"
      );
      if (popoutInput) {
        popoutInput.value = sellingPlanId;
      }
  
      // Update selling plan input
      const sellingPlanInput = document.querySelector(
        'input[name="selling_plan"]'
      );
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
      }
  
      // Update popout display text
      const popoutText = element.querySelector(
        "#subscriptions__frequence-selector [data-popout-text]"
      );
      if (popoutText && optionValue) {
        popoutText.textContent = optionValue;
      }
  
      // Update current selection styling
      const frequencySelector = element.querySelector(
        "#subscriptions__frequence-selector"
      );
      if (frequencySelector) {
        // Remove current selection from all options
        const allOptions = frequencySelector.querySelectorAll(
          ".select-popout__item"
        );
        allOptions.forEach((item) => {
          item.classList.remove("select-popout__item--current");
          const link = item.querySelector(".select-popout__option");
          if (link) link.removeAttribute("aria-current");
        });
  
        // Add current selection to clicked option
        const parentItem = option.closest(".select-popout__item");
        if (parentItem) {
          parentItem.classList.add("select-popout__item--current");
          option.setAttribute("aria-current", "true");
        }
  
        // Close the popup
        frequencySelector.classList.remove("select-popout--active");
      }
  
      // Set the selected plan to bundleSellingPlanElement
      const bundleSellingPlanElement = document.querySelector(
        'input[name="selling_plan"]'
      );
      if (bundleSellingPlanElement && sellingPlanId) {
        bundleSellingPlanElement.value = sellingPlanId;
      }
  
      console.log(
        "Frequency selected:",
        optionValue,
        "Selling Plan ID:",
        sellingPlanId
      );
    };
  
    const setupEventListeners = () => {
      delegate.on(
        "click",
        '[data-action="toggle-subscription"]',
        onToggleSubscription
      );
    };
  
    const onToggleSubscription = (event) => {
      const option = event.target.closest('[data-action="toggle-subscription"]')
        .dataset.option;
      setActiveSubscription(option);
    };
  
    const setActiveSubscription = (option) => {
      const subscriptionOption = element.querySelector(
        ".subscriptions__option--recurring"
      );
      const onetimeOption = element.querySelector(
        ".subscriptions__option--onetime"
      );
  
      if (!subscriptionOption || !onetimeOption) return;
  
      // Reset all icons
      element.querySelectorAll(".subscriptions__icon").forEach((icon) => {
        icon.setAttribute("aria-hidden", "true");
      });
  
      if (option === "recurring") {
        // Activate subscription option
        const activeIcon = subscriptionOption.querySelector(
          ".subscriptions__icons--active"
        );
        const inactiveIcon = onetimeOption.querySelector(
          ".subscriptions__icons--nactive"
        );
  
        if (activeIcon) activeIcon.setAttribute("aria-hidden", "false");
        if (inactiveIcon) inactiveIcon.setAttribute("aria-hidden", "false");
        const subscriptionInput = document.querySelector(
          'input[name="properties[_subscription]"]'
        );
        if (subscriptionInput) {
          subscriptionInput.value = "sub";
          subscriptionInput.disabled = true;
        }
      } else {
        // Activate one-time option
        const activeIcon = onetimeOption.querySelector(
          ".subscriptions__icons--active"
        );
        const inactiveIcon = subscriptionOption.querySelector(
          ".subscriptions__icons--nactive"
        );
  
        if (activeIcon) activeIcon.setAttribute("aria-hidden", "false");
        if (inactiveIcon) inactiveIcon.setAttribute("aria-hidden", "false");
        const subscriptionInput = document.querySelector(
          'input[name="properties[_subscription]"]'
        );
        if (subscriptionInput) {
          subscriptionInput.value = "";
          subscriptionInput.disabled = false;
        }
      }
    };
  
    // Initialize component
    initialize();
    setupEventListeners();
  
    return {
      setActiveSubscription,
      generateFrequencySelector,
      // updateBundleForm,
    };
  };
  
  // Prefill function for bundle quantities
  const prefillBundleQuantities = () => {
    const bundleFormElement = document.querySelector("bundle-form");
    if (!bundleFormElement) return;
  
    // Get the current subscription type - handle cases where form doesn't exist
    const subscriptionInput = document.querySelector(
      'input[name="properties[_subscription]"]'
    );
    // If subscription form doesn't exist, assume OTP
    const interval =
      subscriptionInput && subscriptionInput.value === "sub" ? "sub" : "otp";
  
    // Get bundle max based on subscription type
    const bundleMax = parseInt(
      interval === "otp"
        ? bundleFormElement.dataset.otpBundleMax
        : bundleFormElement.dataset.subBundleMax
    );
  
    if (!bundleMax) return;
  
    // Get all quantity inputs
    const quantityInputs = document.querySelectorAll(
      ".smarch-bundle-product-select-quantity-input"
    );
  
    if (quantityInputs.length === 0) return;
  
    // Calculate prefill quantities based on bundle max
    let quantities = [];
  
    // Check if we have a preset for this bundle max
    if (CONFIG.BUNDLE_PRESETS && CONFIG.BUNDLE_PRESETS[bundleMax]) {
      quantities = [...CONFIG.BUNDLE_PRESETS[bundleMax]];
    } else {
      // Fallback: distribute evenly across available inputs
      const evenDistribution = Math.floor(bundleMax / quantityInputs.length);
      const remainder = bundleMax % quantityInputs.length;
  
      quantities = Array(quantityInputs.length).fill(evenDistribution);
      // Distribute remainder to first inputs
      for (let i = 0; i < remainder; i++) {
        quantities[i]++;
      }
    }
  
    // Set the quantities
    quantityInputs.forEach((input, index) => {
      if (index < quantities.length) {
        input.value = quantities[index] || 0;
      }
    });
  
    // Update the total display
    const totalElement = document.querySelector(".smarch-flavor__amount");
    if (totalElement) {
      const totalQuantity = quantities.reduce((sum, qty) => sum + (qty || 0), 0);
      totalElement.dataset.current = totalQuantity;
      totalElement.textContent = `${totalQuantity} / ${bundleMax}`;
    }
  
    // Update button states by triggering the quantity control component
    const quantityControlElement = document.querySelector("smarch-product-coffy");
    if (quantityControlElement) {
      // Trigger a custom event to update button states
      const event = new CustomEvent("updateButtonStates");
      quantityControlElement.dispatchEvent(event);
    }
  
    setPerUnitPrices(bundleMax);
  };
  
  // Color Selector Component
  const createColorSelector = (element) => {
    const delegate = createDelegate(element);
  
    const initialize = () => {
      // Check if color selector exists
      const colorBlocks = element.querySelectorAll(".smarch-color__block");
  
      if (colorBlocks.length === 0) {
        // No color selector present - show all images
        const mediaSlides = document.querySelectorAll(
          "[data-product-single-media-wrapper]"
        );
        mediaSlides.forEach((slide) => {
          slide.classList.remove("media--hidden");
        });
        return;
      }
  
      // Color selector exists - proceed with normal logic
      const activeColor = element.querySelector(".smarch-color__block.is-active");
      if (!activeColor) {
        const firstColor = element.querySelector(".smarch-color__block");
        if (firstColor) {
          firstColor.classList.add("is-active");
          console.log("Default color selected:", firstColor.dataset.color);
          filterProductMedia(firstColor.dataset.color);
        }
      } else {
        filterProductMedia(activeColor.dataset.color);
      }
    };
  
    const setupEventListeners = () => {
      delegate.on("click", '[data-action="toggle-color"]', onToggleColor);
    };
  
    const onToggleColor = (event) => {
      const colorBlock = event.target.closest('[data-action="toggle-color"]');
      if (!colorBlock) return;
  
      // Remove active class from all color blocks
      element.querySelectorAll(".smarch-color__block").forEach((block) => {
        block.classList.remove("is-active");
      });
  
      // Add active class to clicked color block
      colorBlock.classList.add("is-active");
  
      const selectedColor = colorBlock.dataset.color;
      console.log("Color selected:", selectedColor);
  
      filterProductMedia(selectedColor);
    };
  
    const filterProductMedia = (selectedColor) => {
      const mediaSlides = document.querySelectorAll(
        "[data-product-single-media-wrapper]"
      );
      let hasMatchingMedia = false;
      let firstMatchingMedia = null;
  
      mediaSlides.forEach((slide) => {
        const mediaColor = slide.dataset.mediaColor;
  
        // Show images that match the selected color OR have no color (generic images)
        if (mediaColor === selectedColor || !mediaColor || mediaColor === "") {
          slide.classList.remove("media--hidden");
          if (!firstMatchingMedia && mediaColor === selectedColor) {
            firstMatchingMedia = slide;
          }
          hasMatchingMedia = true;
        } else {
          slide.classList.add("media--hidden");
        }
      });
  
      // If no specific color images found, show all images
      if (!hasMatchingMedia) {
        mediaSlides.forEach((slide) => {
          slide.classList.remove("media--hidden");
        });
      } else if (firstMatchingMedia) {
        updateThumbnails(selectedColor);
  
        const mediaId = firstMatchingMedia.dataset.id;
        if (mediaId) {
          const thumbnail = document.querySelector(
            `[data-thumbnail-id="${mediaId}"]`
          );
          if (thumbnail) {
            thumbnail.click();
          }
        }
      }
    };
  
    const updateThumbnails = (selectedColor) => {
      const thumbnails = document.querySelectorAll("[data-thumbnail-id]");
  
      thumbnails.forEach((thumbnail) => {
        const thumbnailId = thumbnail.dataset.thumbnailId;
        const correspondingMedia = document.querySelector(
          `[data-id="${thumbnailId}"]`
        );
  
        if (correspondingMedia) {
          const mediaColor = correspondingMedia.dataset.mediaColor;
  
          if (mediaColor === selectedColor || !mediaColor) {
            thumbnail.style.display = "";
          } else {
            thumbnail.style.display = "none";
          }
        }
      });
    };
  
    // Initialize component
    initialize();
    setupEventListeners();
  
    return {
      onToggleColor,
    };
  };
  
  // Initialize components when DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    // Initialize Quantity Control components
  
    setTimeout(() => {
      const coffyQuantityProducts = getCoffyQuantityProducts();
      if (coffyQuantityProducts && coffyQuantityProducts.length > 1) {
        // Find the first quantity block element
        const firstQuantityBlock = document.querySelector(
          ".smarch-quantity__block"
        );
        if (firstQuantityBlock) {
          document
            .querySelectorAll(".smarch-quantity__block")
            .forEach((block) => {
              block.classList.remove("is-active");
            });
          firstQuantityBlock.classList.add("is-active");
          const quantityControlElement = document.querySelector(
            "smarch-product-coffy"
          );
          if (quantityControlElement && quantityControlElement._quantityControl) {
            const mockEvent = {
              target: firstQuantityBlock,
            };
            quantityControlElement._quantityControl.changeQuantity(mockEvent);
          }
        }
      }
    }, 0);
  
    document.querySelectorAll("smarch-product-coffy").forEach((element) => {
      createQuantityControl(element);
    });
  
    // Initialize Subscription Control components
    document.querySelectorAll(".subscriptions").forEach((element) => {
      element._subscriptionControl = createSubscriptionControl(element);
    });
  
    // Initialize Color Selector components
    const colorSelectors = document.querySelectorAll(".smarch-color__selector");
    colorSelectors.forEach((element) => {
      createColorSelector(element);
    });
  
    // If no color selectors exist, ensure all media is visible
    if (colorSelectors.length === 0) {
      const mediaSlides = document.querySelectorAll(
        "[data-product-single-media-wrapper]"
      );
      mediaSlides.forEach((slide) => {
        slide.classList.remove("media--hidden");
      });
    }
  
    // Initialize bundle form submission
    const bundleForms = document.querySelectorAll(".smarch-bundle-form");
    bundleForms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const submitButton = form.querySelector(".product__submit__bundle");
        addToCart(submitButton);
      });
    });
  
    // Initialize bundle submit buttons
    const bundleSubmitButtons = document.querySelectorAll(
      ".product__submit__bundle"
    );
    bundleSubmitButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        addToCart(this);
      });
    });
  });
  